// @flow
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

/* stylelint-disable */
/* eslint-disable */

export const Icon: any = styled.span`
  padding: 9px;
  border-right: 1px solid ${({ theme }) => theme.colors.uiM};
  margin-right: 12px;
  transition: all 0.25s ease;

  :hover,
  :focus {
    border-color: ${({ theme }) => theme.colors.accent1L};
  }

  svg {
    display: block;
    width: 24px;
    height: 24px;
  }
`;

export const OptionsInner: any = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: 1fr 0.8fr 0.6fr auto;
  padding: 2rem;
  border: 2px solid ${({ theme }) => theme.colors.ui};
  border-radius: 4px;

  > h4 {
    ${getFont(2)}
    font-weight: 600;
    margin-bottom: 20px;
  }

  > span:before {
    content: ' ';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 10px;
    border: 2px solid ${({ theme }) => theme.colors.primary};

    // inner shadow simulating an inner border
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.terciaryLL};
  }

  > div {
    ${getFont(3)}
    font-weight: 700;
  }

  > div > span {
    ${getFont(0)}
    font-weight: 400;
    color: ${({ theme }) => theme.colors.terciaryD};
    ${({ color }) => color && `color: ${color};`}
  }

  ${({ background }) => background && `background: ${background};`}
  ${({ color }) => color && `color: ${color};`}

  ${({ plus, color, color2 }) =>
    plus &&
    `
    display: flex;
    flex-direction: column;

    border: none;
    border-radius: 0;

    svg {
      margin-bottom: 30px;
    }

    > h4 {
      font-weight: 300;
      ${getFont(3)}
      ${color2 && `color: ${color2};`}

      b {
        font-weight: 500;
      }
    }

    .price {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-weight: 300;
      ${color2 && `color: ${color2};`}
    }
      
    .bullet {
      font-weight: 300;
      ${getFont(1)}
      
      :before {
        content: ' ';
        display: inline-block;
        width: 6px;
        height: 6px;
        margin-bottom:2px;
        border-radius: 50%;
        margin-right: 10px;
        border: 4px solid ${color};
      }
    }
  `}

  ${maxMediaQueries.phablet`
    ${({ plus }) =>
      plus &&
      `
      > h4 {
        ${getFont(2)}
      }
    `}
  `}
`;

export const Bullets: any = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  padding-left: 10px;

  .bullet {
    ${({ fontSize }) => getFont(fontSize)}
    opacity: 0.9;

    ${maxMediaQueries.phablet`
      ${({ fontSize }) => getFont(fontSize - 2)}
    `}
  }
`;

export const Expand: any = styled.div`
  position: relative;
  flex-grow: 1;
  width: 100%;
  height: 1px;
`;

export const Price: any = styled.h5`
  ${({ priceFontSize }) => getFont(priceFontSize || 3)}
  ${({ priceFontWeight }) => priceFontWeight && `font-weight: ${priceFontWeight};`}
  ${({ strikethrough }) => strikethrough && 'text-decoration: line-through;'}

  span {
    display: inline-block;
    vertical-align: middle;
    margin-left: 4px;
    ${({ priceFontSize }) => getFont(priceFontSize ? priceFontSize - 2 : 1)}
    font-weight: 200;
  }
`;

export const ProfDisclaimer: any = styled.div`
  margin-top: 20px;
  text-align: center;

  span {
    opacity: 0.8;
  }

  p {
    ${getFont(0)}
    font-weight: 400;

    a {
      font-weight: 500;
      color: inherit;
      text-decoration: underline;
    }
  }
`;

export const ButtonContainer: any = styled.div`
  // absolute outside of its card at the bottom
  ${({ absolute }) =>
    absolute
      ? `
    position: absolute;
    bottom: -80px;
    left: 0;
    right: 0;
    `
      : 'margin-top: 8px;'}

  transition: all 0.25s ease;

  width: 100%;
  display: flex;
  justify-content: center;

  a {
    text-align: center;
    ${getFont(1)}
    font-weight: 400;
    color: ${({ theme, color }) => color || theme.colors.font};

    padding: 4px 30px;
    background: ${({ theme, background }) => background || theme.plus.secondary};
    border-radius: 4px;
  }
`;

export const Option: any = styled.button`
  width: 100%;
  text-align: center;

  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 2px;
  font-weight: 500;
  color: #fff;
`;

/* stylelint-enable */
/* eslint-enable */
